import { render } from "./CoursesStatisticsComponent.vue?vue&type=template&id=58186c2c&scoped=true"
import script from "./CoursesStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./CoursesStatisticsComponent.vue?vue&type=script&lang=js"

import "./CoursesStatisticsComponent.vue?vue&type=style&index=0&id=58186c2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58186c2c"]])

export default __exports__